export default __webpack_public_path__ + "static/inventory-system-4-c5813202f339112da2e343f38c0a2849.png";